import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const reactOpts = {
  transKeepBasicHtmlNodesFor: ['b', 'li', 'ul']
}

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      whitelist: ['fr', 'en'],
      fallbackLng: 'fr',
      backend: {
        loadPath: '/langs/{{lng}}.json',
        allowMultiLoading: false
      },
      interpolation: {
        escapeValue: false,
        format: (value, format) => {
          if (format === 'kbis') {
            return value === 'FR' ?
            'KBIS' :
            'BCE'
          } else {
            return value
          }
        }
      },
      react: reactOpts
    })

export default i18n
